import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const ContentStyled = styled(Stack)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
}));

export const EmptyContentStyled = styled(Stack)(() => ({
  margin: 'auto',
}));
